module.exports = __webpack_public_path__ + "static/en-1-b41a3b014daaa8905681450822d74d83.png";